'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowLoop = function TiArrowLoop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 13.3h-3.5l2.2-2.1c0.6-0.7 0.6-1.7 0-2.4s-1.7-0.6-2.4 0l-6.2 6.2 6.2 6.2c0.3 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c0.6-0.7 0.6-1.7 0-2.4l-2.2-2.1h3.5c2.3 0 4.2 2.2 4.2 5s-2.3 5-5 5h-13.4c-2.7 0-5-2.3-5-5s2.3-5 5-5c1 0 1.7-0.8 1.7-1.7s-0.7-1.7-1.7-1.7c-4.6 0-8.3 3.8-8.3 8.4s3.7 8.3 8.3 8.3h13.4c4.6 0 8.3-3.7 8.3-8.3s-3.4-8.4-7.5-8.4z' })
        )
    );
};

exports.default = TiArrowLoop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-loop.js
// module id = 2976
// module chunks = 0